export default "__VITE_ASSET__BsA80omf__"